<div
  class="ticket-status smart-card-wrap"
  [style.--sc-basis]="100 - 2 * offset + '%'"
  [style.--sc-offset]="offset + '%'"
  [style.margin.px]="margin"
>
  <div class="flex-initial">
    @if (backButton) {
      <button mat-raised-button color="primary" navigateBack [style.margin-bottom.px]="10">
        <mat-icon class="materialSendIcon">arrow_back</mat-icon>
        <span class="customSendIconLeft"></span>
        <span [innerHtml]="'back' | translate | uppercase"></span>
      </button>
    }
    <ng-content select="[navigation]"></ng-content>
  </div>

  <div class="fill d-flex justify-center items-center">
    <mat-card
      appearance="raised"
      class="smart-card-component w-full"
      [style.padding.px]="padding"
    >
      <ng-content></ng-content>
    </mat-card>
  </div>
</div>
